import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useRemoveFirmUsers } from '../../queries/use-remove-firm-users';

type RemoveUsersConfirmDialogProps = {
    userIds: string[];
    isOpen: boolean;
    onClose: () => void;
    onRemove: () => void;
};

function RemoveUsersConfirmDialog({ userIds, isOpen, onClose, onRemove }: RemoveUsersConfirmDialogProps): JSX.Element {
    const removeUsersQuery = useRemoveFirmUsers();

    function removeUsers(): void {
        removeUsersQuery.mutate(
            { ids: userIds },
            {
                onSuccess: () => {
                    onRemove();
                    toastNotification('success', `${userIds.length} ${userIds.length === 1 ? 'user' : 'users'} removed!`);
                },
            }
        );
    }

    return (
        <Dialog
            description={`Do you want to remove ${
                userIds.length > 1 ? `${userIds.length} users` : 'this user'
            } from the current firm? Removed users cannot be recovered.`}
            onClose={onClose}
            onPrimaryActionClick={removeUsers}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Remove"
            secondaryAction="Cancel"
            title={`Remove ${userIds.length > 1 ? 'Users' : 'User'} from Firm`}
            type="error"
            isLoading={removeUsersQuery.isLoading}
        />
    );
}

export default RemoveUsersConfirmDialog;
